import React, { useEffect, useRef, useState, createContext } from "react";
import rainicon from "../images/rainny.gif";
import cloudicon from "../images/cloud.gif";
import hazeicon from "../images/haze.png";
import sunicon from "../images/sun.gif";
import sideicon from "../images/sideicon.png";
import close from "../images/close.png";
import sidemap from "../images/mapside.png";
import sideweather from "../images/weatherside.png";
import windbg from "../images/windbg.png";
import smile1 from "../video/smile1.gif";
import smile2 from "../video/smile2.gif";
import smile3 from "../video/smile3.gif";
import smile4 from "../video/smile4.gif";
import smile6 from "../video/smile6.gif";
import smile10 from "../video/smile10.gif";
import smile8 from "../video/smile8.gif";
import smile9 from "../video/smile9.gif";
import bg1 from "../video/bg1.gif";
import bg2 from "../video/bg2.gif";
import bg3 from "../video/bg3.gif";
import bg4 from "../video/bg4.gif";
import bg5 from "../video/bg5.jpeg";
import bg6 from "../video/bg6.jpg";
import bg7 from "../video/bg7.jpg";
import bg8 from "../video/bg8.gif";
import tempbg from "../video/pbg1.jpg";
import person2 from "../video/person2.png";
import person3 from "../video/person3.png";
import person4 from "../video/person4.png";
import person5 from "../video/person5.png";
import person6 from "../video/person6.png";
import person7 from "../video/person7.gif";
import person8 from "../video/person8.png";
import person9 from "../video/person9.png";
import person10 from "../video/person10.png";
import person12 from "../video/person12.png";
import person13 from "../video/person13.png";
import person14 from "../video/person14.png";
import person15 from "../video/person15.png";
import person16 from "../video/person16.png";
import person17 from "../video/person17.png";
import cityname from "../countries.json";
import Fuse from "fuse.js";
import { Route, Link, Routes } from "react-router-dom";
import { ThreeCircles } from "react-loader-spinner";
import {
	WiBarometer,
	WiHumidity,
	WiSandstorm,
	WiThermometer,
} from "react-icons/wi";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import Metter from "./Metter";
import Wind from "./Wind";
import { motion } from "framer-motion";
import Weatherpage from "./Weatherpage";
import Mappage from "./Mappage";
export const data = createContext();
const Index = () => {
	let [city, setCity] = useState();
	let [search, setSearch] = useState("");
	let [image, setImage] = useState("");
	let [coord, setCoord] = useState({ lat: "", log: "" });
	let [forcast, setForcast] = useState(false);
	let [list, setList] = useState(false);
	let [sidebar, setSidebar] = useState(false);
	let [filteredData, setFilteredData] = useState([]);
	let [local, setLocal] = useState(false);
	let inputRef = useRef(null);
	const options = {
		threshold: 0.1,
		minMatchCharLength: 2,
		shouldSort: true,
		findAllMatches: false,
		useExtendedSearch: true,
	};
	useEffect(() => {
		const fuse = new Fuse(cityname, options);
		if (search) {
			const searchResults = fuse.search(search);
			setFilteredData(searchResults);
		} else {
			setFilteredData([]);
		}
	}, [search]);
	let searchhistory = JSON.parse(localStorage.getItem("searchHistory"))
		?.slice(-5)
		?.reverse();

	const fetchWeatherData = async (searchvalue) => {
		try {
			let response = await fetch(
				`https://api.openweathermap.org/data/2.5/weather?q=${searchvalue}&appid=e471830d673881c66f8638631be8eb4c&units=Metric`
			);
			if (response.ok) {
				let result = await response.json();
				setCity(result);
				setImage(result.weather);
				setCoord({ lat: result.coord.lat, lon: result.coord.lon });
				setSearch("");
				let getdata = JSON.parse(localStorage.getItem("searchHistory")) || [];
				const newSearchData = {
					searchCity: searchvalue,
					searchDay: new Date(city.dt * 1000).toDateString(),
					searchTime: new Date(city.dt * 1000).toLocaleTimeString(),
				};
				const filterdata = getdata.filter(
					(val) => val.searchCity !== newSearchData.searchCity
				);
				filterdata.push(newSearchData);

				localStorage.setItem("searchHistory", JSON.stringify(filterdata));
			} else {
				if (search.length !== 0) {
					alert("city not found");
					setSearch("");
				}
			}
		} catch (error) {
			// alert("not valid");
		}
	};
	const fetchForecastData = async (e) => {
		try {
			let response = await fetch(
				`https://api.openweathermap.org/data/2.5/forecast?q=${e}&appid=e471830d673881c66f8638631be8eb4c&units=metric`
			);
			if (response.ok) {
				let result = await response.json();
				setForcast(result);
				// console.log(result);
			} else {
				// if (search !== 0) {
				// 	alert("city not found");
				// }
			}
		} catch (error) {
			alert("Invalid");
		}
	};

	const handleKeyPress = (e) => {
		if (e.key === "Enter") {
			fetchWeatherData(e.target.value);
			fetchForecastData(e.target.value);
			setList(false);
		}
	};

	const handleli = (e) => {
		const cityName = e.target.textContent;
		setList(false);
		setLocal(false);
		fetchWeatherData(cityName);
		fetchForecastData(cityName);
	};

	const getBackgroundImage = () => {
		switch (city ? image[0].main : false) {
			case "Clouds":
				return `linear-gradient(360deg, #4aa6f2f5, transparent)`;
			case "Haze":
				return `linear-gradient(360deg, #000000d6, transparent)"`;
			case "Rain":
				return ` linear-gradient(360deg, #00eaffb0, transparent)`;
			case "Clear":
				return `linear-gradient(360deg, #fff700, transparent)`;
			case "Drizzle":
				return `linear-gradient(360deg, #00eaffb0, transparent)`;
			case "Smoke":
				return `linear-gradient(360deg, #000000d6, transparent)`;
			case "Mist":
				return `linear-gradient(360deg, #000000d6, transparent)`;
			default:
				return `linear-gradient(360deg, #4aa6f2f5, transparent)`;
		}
	};

	const mainStyle = {
		backgroundImage: getBackgroundImage(),
	};
	const getBackgroundIcon = () => {
		switch (city ? image[0].main : false) {
			case "Clouds":
				return `${cloudicon}`;
			case "Haze":
				return `${hazeicon}`;
			case "Rain":
				return `${rainicon}`;
			case "Clear":
				return `${sunicon}`;
			case "Drizzle":
				return `${rainicon}`;
			case "Smoke":
				return `${hazeicon}`;
			case "Mist":
				return `${hazeicon}`;
			default:
				return `${""}`;
		}
	};
	const iconStyle = {
		src: getBackgroundIcon(),
	};

	const coordinates = {
		lat: coord.lat,
		lng: coord.lon,
	};
	const mapStyles = {
		height: "85vh",
		width: "100%",
		borderRadius: "20px",
		PointerEvent: "none",
		display: "flex",
	};

	const humiditylevel = () => {
		let humidity = city?.main.humidity;
		// let humidity = 30;
		switch (humidity ? true : false) {
			case humidity < 0 && humidity < 10:
				return ["#b9fdff", "1px"];
			case humidity >= 10 && humidity < 20:
				return ["#a9dcf4", "2px"];
			case humidity >= 20 && humidity < 30:
				return ["#9da6e5", "3px"];
			case humidity >= 30 && humidity < 40:
				return ["#cc86ec", "4px"];
			case humidity >= 40 && humidity < 50:
				return ["#cc86ec", "5px"];
			case humidity >= 50 && humidity < 60:
				return ["#cc86ec", "6px"];
			case humidity >= 60 && humidity < 70:
				return ["#cc86ec", "7px"];
			case humidity >= 70 && humidity < 80:
				return ["#cc86ec", "8px"];
			case humidity >= 80:
				return ["#f288ff", "9px"];
			default:
				return "transparent";
		}
	};

	const handleHumidity = {
		backdropFilter: `blur(${humiditylevel()[1]})`,
	};

	const windlevel = () => {
		let wind = city?.wind.speed;
		// console.log(wind);

		switch (wind ? true : false) {
			case wind >= 0 && wind < 2:
				return "10s";
			case wind >= 2 && wind < 3:
				return "8s";
			case wind >= 3 && wind < 5:
				return "6s";
			case wind >= 5 && wind < 8:
				return "4s";
			case wind >= 8 && wind < 11:
				return "2s";
			case wind >= 11 && wind < 14:
				return "1s";
			case wind >= 14 && wind < 17:
				return "0.8s";
			case wind >= 17 && wind < 21:
				return "0.6s";
			case wind >= 21 && wind < 24:
				return "0.4s";
			case wind >= 24 && wind < 28:
				return "0.3s";
			case wind >= 28 && wind < 33:
				return "0.2";
			case wind >= 33:
				return "0.1s";
			default:
				return "transparent";
		}
	};
	const handleWind = {
		animationDuration: windlevel(),
	};
	const pressurelevel = () => {
		let pressure = city?.main.pressure;
		switch (pressure ? true : false) {
			case pressure >= 1000 && pressure < 1003:
				return "-62deg";
			case pressure >= 1003 && pressure < 1006:
				return "-45deg";
			case pressure >= 1006 && pressure < 1009:
				return "-28deg";
			case pressure >= 1009 && pressure < 1012:
				return "-13deg";
			case pressure >= 1012 && pressure < 1015:
				return "0deg";
			case pressure >= 1015 && pressure < 1018:
				return "13deg";
			case pressure >= 1018 && pressure < 1021:
				return "28deg";
			case pressure >= 1021 && pressure < 1024:
				return "45deg";
			case pressure >= 1025:
				return "62deg";
			default:
				return "-70deg";
		}
	};
	const handlePressure = {
		transform: `rotate(${pressurelevel()})`,
	};
	const feellike = () => {
		let feel = city?.main.feels_like;

		switch (feel ? true : false) {
			case feel >= -20 && feel < -10:
				return [`${smile1}`, `${bg1}`];
			case feel >= -10 && feel < 0:
				return [`${smile9}`, `${bg2}`];
			case feel >= 0 && feel < 10:
				return [`${smile8}`, `${bg3}`];
			case feel >= 10 && feel < 20:
				return [`${smile6}`, `${bg8}`];
			case feel >= 20 && feel < 30:
				return [`${smile2}`, `${bg6}`];
			case feel >= 30 && feel < 40:
				return [`${smile3}`, `${bg4}`];
			case feel >= 40 && feel < 50:
				return [`${smile4}`, `${bg5}`];
			case feel >= 50:
				return [`${smile10}`, `${bg7}`];
			default:
				return [`${smile1}`, `${bg7}`];
		}
	};
	const handlefeellike = {
		src: feellike()[0],
		srcbg: feellike()[1],
	};
	const mintemp = () => {
		let temp = city?.main.temp_min;

		switch (temp ? true : false) {
			case temp >= -20 && temp < -10:
				return `${person3}`;
			case temp >= -10 && temp < 1:
				return `${person2}`;
			case temp >= 1 && temp < 10:
				return `${person8}`;
			case temp >= 10 && temp < 20:
				return `${person5}`;
			case temp >= 20 && temp < 30:
				return `${person4}`;
			case temp >= 30 && temp < 40:
				return `${person9}`;
			case temp >= 40 && temp < 50:
				return `${person6}`;
			case temp >= 50:
				return `${person7}`;
			default:
				return `${person2}`;
		}
	};
	const maxtemp = () => {
		let temp = city?.main.temp_max;
		switch (temp ? true : false) {
			case temp >= -20 && temp < -10:
				return `${person12}`;
			case temp >= -10 && temp < 1:
				return `${person2}`;
			case temp >= 1 && temp < 10:
				return `${person13}`;
			case temp >= 10 && temp < 20:
				return `${person14}`;
			case temp >= 20 && temp < 30:
				return `${person15}`;
			case temp >= 30 && temp < 40:
				return `${person10}`;
			case temp >= 40 && temp < 50:
				return `${person16}`;
			case temp >= 50:
				return `${person17}`;
			default:
				return `${person2}`;
		}
	};
	const handlemintemp = {
		src: mintemp(),
	};
	const handlemaxtemp = {
		src: maxtemp(),
	};
	const handlesidebar = () => {
		setSidebar(true);
	};
	const handleclose = () => {
		setSidebar(false);
	};
	const successCallback = async (position) => {
		const lat = position.coords.latitude;
		const lon = position.coords.longitude;
		setCoord({ lat, lon });

		try {
			const response = await fetch(
				`https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=e471830d673881c66f8638631be8eb4c&units=metric`
			);
			if (response.ok) {
				const data = await response.json();
				fetchForecastData(data.name);
				fetchWeatherData(data.name);
			} else {
				console.error("Failed to fetch forecast data.");
			}
		} catch (error) {
			console.error("Error while fetching forecast data:", error);
		}
	};

	const errorCallback = (error) => {
		console.log(error);
	};

	useEffect(() => {
		navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
	}, []);

	useEffect(() => {
		const handleBlur = (e) => {
			if (inputRef.current && !inputRef.current.contains(e.target)) {
				setLocal(false);
			}
		};

		document.addEventListener("click", handleBlur);

		return () => {
			document.removeEventListener("click", handleBlur);
		};
	}, []);
	const boxdata = [
		{
			bgimage: bg2,
			boxicon: <WiHumidity />,
			boxname: "Humidity",
			boxdata: city?.main.humidity,
			boxdatashow: "%",
			class: "humiditybox",
			boxclass: "smallboxhumidity",
			blurfilter: handleHumidity,
		},
		{
			boximage: <Metter handlemetter={handlePressure} />,
			bgcolor: "rgb(0,0,0,0.4)",
			boxicon: <WiBarometer />,
			boxname: "Pressure",
			boxdata: city?.main.pressure,
			boxdatashow: "%",
			boxclass: "smallbox",
		},
		{
			boximage: <Wind handlewind={handleWind} />,
			bgimage: windbg,
			boxicon: <WiSandstorm />,
			boxname: "Wind",
			boxdata: city?.wind.speed,
			boxdatashow: "m/s",
			boxclass: "smallboxwind",
		},
		{
			boximage: <img src={handlefeellike.src} alt="smileimage" />,
			bgimage: handlefeellike.srcbg,
			boxicon: <WiThermometer />,
			boxname: "Feels Like",
			boxdata: city?.main.feels_like,
			boxdatashow: "°C",
			boxclass: "smallbox",
		},

		{
			textcolor: "white",
			elements: (
				<div className="maintempdiv">
					<div className="tempdiv">
						<div className="svgtemp">
							{<img src={handlemintemp.src} alt="tempimage" />}
						</div>

						<div>
							<span className="smallboxicon">
								{<FaArrowDown />} {"Min Temp"}
							</span>
						</div>

						<div>
							<span className="boxdata">
								{`${city?.main.temp_min}`}
								{"°C"}
							</span>
						</div>
					</div>
					<div className="tempdiv" style={{ position: "relative" }}>
						<div className="svgtemp" style={{ left: "0px", top: "-12px" }}>
							{<img src={handlemaxtemp.src} alt="tempimage" />}
						</div>

						<div>
							<span className="smallboxicon">
								{<FaArrowUp />} {"Max Temp"}
							</span>
						</div>

						<div>
							<span className="boxdata">
								{`${city?.main.temp_max}`}
								{"°C"}
							</span>
						</div>
					</div>
				</div>
			),

			bgimage: tempbg,
			boxclass: "smallbox",
		},
	];
	const forcastdaydata = forcast
		? [
				{
					date: new Date(forcast?.list[5].dt * 1000).toLocaleDateString(),
					days: new Date(forcast?.list[5]?.dt * 1000).toLocaleDateString(
						"en-US",
						{
							weekday: "long",
						}
					),
					weather: forcast?.list[5].weather[0].main,
					icon: forcast?.list[5].weather[0].icon,
					max: Math.ceil(forcast?.list[5].main.temp_max),
					min: Math.floor(forcast?.list[5].main.temp_min),
				},
				{
					date: new Date(forcast?.list[13].dt * 1000).toLocaleDateString(),
					days: new Date(forcast?.list[13]?.dt * 1000).toLocaleDateString(
						"en-US",
						{
							weekday: "long",
						}
					),
					weather: forcast?.list[13].weather[0].main,
					icon: forcast?.list[13].weather[0].icon,
					max: Math.ceil(forcast?.list[13].main.temp_max),
					min: Math.floor(forcast?.list[13].main.temp_min),
				},
				{
					date: new Date(forcast?.list[21].dt * 1000).toLocaleDateString(),
					days: new Date(forcast?.list[21]?.dt * 1000).toLocaleDateString(
						"en-US",
						{
							weekday: "long",
						}
					),
					weather: forcast?.list[21].weather[0].main,
					icon: forcast?.list[21].weather[0].icon,
					max: Math.ceil(forcast?.list[21].main.temp_max),
					min: Math.floor(forcast?.list[21].main.temp_min),
				},
				{
					date: new Date(forcast?.list[29].dt * 1000).toLocaleDateString(),
					days: new Date(forcast?.list[29]?.dt * 1000).toLocaleDateString(
						"en-US",
						{
							weekday: "long",
						}
					),
					weather: forcast?.list[29].weather[0].main,
					icon: forcast?.list[29].weather[0].icon,
					max: Math.ceil(forcast?.list[29].main.temp_max),
					min: Math.floor(forcast?.list[29].main.temp_min),
				},
				{
					date: new Date(forcast?.list[37].dt * 1000).toLocaleDateString(),
					days: new Date(forcast?.list[37]?.dt * 1000).toLocaleDateString(
						"en-US",
						{
							weekday: "long",
						}
					),
					weather: forcast?.list[37].weather[0].main,
					icon: forcast?.list[37].weather[0].icon,
					max: Math.ceil(forcast?.list[37].main.temp_max),
					min: Math.floor(forcast?.list[37].main.temp_min),
				},
		  ]
		: [];
	const forcasttimedata = forcast
		? [
				{
					date: new Date(forcast?.list[0].dt * 1000).toLocaleTimeString([], {
						hour: "2-digit",
						minute: "2-digit",
					}),
					icon: forcast?.list[0].weather[0].icon,
					weather: forcast?.list[0].weather[0].main,
					max: Math.ceil(forcast?.list[0].main.temp_max),
					min: Math.floor(forcast?.list[0].main.temp_min),
				},
				{
					date: new Date(forcast?.list[1].dt * 1000).toLocaleTimeString([], {
						hour: "2-digit",
						minute: "2-digit",
					}),
					weather: forcast?.list[1].weather[0].main,
					icon: forcast?.list[1].weather[0].icon,
					max: Math.ceil(forcast?.list[1].main.temp_max),
					min: Math.floor(forcast?.list[1].main.temp_min),
				},
				{
					date: new Date(forcast?.list[2].dt * 1000).toLocaleTimeString([], {
						hour: "2-digit",
						minute: "2-digit",
					}),
					weather: forcast?.list[2].weather[0].main,
					icon: forcast?.list[2].weather[0].icon,
					max: Math.ceil(forcast?.list[2].main.temp_max),
					min: Math.floor(forcast?.list[2].main.temp_min),
				},
		  ]
		: [];
	const weatherData = {
		currenttime: new Date(city?.dt * 1000).toDateString(),
		cityName: city?.name,
		citycountry: city?.sys.country,
		icon: iconStyle.src,
		temprature: Math.round(city?.main.temp),
		weather: city?.weather[0].main,
		condition1: true,
		condition2: true,
	};

	return (
		<>
			<data.Provider
				value={{
					boxdata,
					forcastdaydata,
					forcasttimedata,
					weatherData,
					coordinates,
					mapStyles,
				}}
			>
				<div className="maindiv">
					{city && (
						<div className={sidebar ? "leftsidebar" : "leftsidebar1"}>
							<div
								className="sidebarheader"
								style={{ visibility: sidebar ? "visible" : "hidden" }}
							>
								<h1>Weather App</h1>
							</div>
							<div
								className="sidelistitem"
								style={{ visibility: sidebar ? "visible" : "hidden" }}
							>
								<ul>
									<Link
										to="/map"
										onClick={() => {
											setSidebar(false);
										}}
									>
										<li>
											<img src={sidemap} alt="mapimage" />
											Map
										</li>
									</Link>

									<Link
										to="/"
										onClick={() => {
											setSidebar(false);
										}}
									>
										<li>
											<img src={sideweather} alt="mapimage" />
											Weather
										</li>
									</Link>
								</ul>
							</div>
						</div>
					)}
					<div className="headermain">
						<div className="header">
							<div className="title">
								{city && (
									<div className="sideicon">
										<img
											src={sidebar ? close : sideicon}
											alt="sideicon"
											onClick={sidebar ? handleclose : handlesidebar}
										/>
									</div>
								)}
								<h1
									className={sidebar ? "titlenameoff" : "titlenameon"}
									style={{ marginLeft: city ? "0px" : "25px" }}
								>
									Weather App
								</h1>
							</div>
							<div className={sidebar ? "searchboxclose" : "searchbox"}>
								<div className="search">
									<input
										type="text"
										placeholder="Search...."
										value={search}
										onChange={(e) => {
											setSearch(e.target.value);
											if (e.target.value.length !== 0) {
												setList(true);
											} else {
												setList(false);
											}
										}}
										onKeyDown={handleKeyPress}
										onFocus={() => {
											setLocal(true);
										}}
										ref={inputRef}
									/>
								</div>
								<div
									className="searchlist"
									style={{ display: list || local ? "block" : "none" }}
								>
									<ul>
										{list ? (
											filteredData?.map((city, index) => (
												<li key={index} onClick={handleli}>
													{city.item}
												</li>
											))
										) : local ? (
											searchhistory?.map((i, index) => (
												<li key={index} onClick={handleli}>
													{i.searchCity}
												</li>
											))
										) : (
											<></>
										)}
									</ul>
								</div>
							</div>
						</div>

						{!city ? (
							<div className="loder">
								<ThreeCircles
									height="100"
									width="100"
									color="#1ea9c2"
									wrapperStyle={{}}
									wrapperClass=""
									visible={true}
									ariaLabel="three-circles-rotating"
									outerCircleColor="#1ea9c1"
									innerCircleColor="#1ea9c3"
									middleCircleColor="#1ea9c5"
									transition="1s"
								/>
							</div>
						) : (
							<motion.div
								initial={{ opacity: 0, scale: 0.8 }}
								animate={{ opacity: 1, scale: 1 }}
								exit={{ opacity: 0, scale: 0.8 }}
								transition={{ duration: 0.5 }}
							>
								<div className="maincontent" style={mainStyle}>
									<Routes>
										<Route path="/" element={<Weatherpage />} />
									</Routes>
									<Routes>
										<Route path="/map" element={<Mappage />} />
									</Routes>
								</div>
							</motion.div>
						)}
					</div>
				</div>
			</data.Provider>
		</>
	);
};

export default Index;
